<template>
  <div class="dashboard-item">
    <el-card @click.native="itemClick">
      <div class="payload-wrapper">
        <div class="img-wrapper">
          <img class="img" ref="MyImageItem">
        </div>
        <div class="content-wrapper">
          <h3>{{product.name}}</h3>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { XCircleIcon } from 'vue-feather-icons';
import noPreview from '../assets/img/no-preview-available.jpg';
import loadImage from '../../static/js/loadImage/load-image';

export default {
  data() {
    return {
      noPreview,
    };
  },
  props: ['product', 'imgUrl'],
  methods: {
    itemClick() {
      this.$emit('onItemClick');
    },
    setImg() {
      const image = this.getImageItemElement;
      loadImage(
        this.imgUrl,
        (img) => {
          if (img.type === 'error') {
            image.src = this.noPreview;
          } else {
            image.src = this.imgUrl;
          }
        },
      );
    },
  },
  computed: {
    getImageItemElement() {
      return this.$refs.MyImageItem;
    },
  },
  watch: {
    imgUrl() {
      this.setImg();
    },
  },
  components: {
    XCircleIcon,
  },
  mounted() {
    this.setImg();
  },
};
</script>

<style lang="scss">
  $break-small: 500px;
  .dashboard-item {
    position: relative;    
    height: 100%;
    cursor: pointer;
    .el-card {
      height: 100%;
      .el-card__body {
        height: calc(100% - 40px);
        .payload-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 100%;
          .img-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            .img {
              max-width: 100%;
              max-height: 100%;
              border-radius: 4px;
              height: auto;
            }
          }
          .content-wrapper {
            text-align: center;
            color: #606266;          
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DashboardItem.vue?6cf92992